import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect, HorizontalSelect, StudentCard, ApiResponseHelper } from 'omni-common-ui';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as UiState } from 'data/UiState';
import { getHfv4BandForScore } from '../ScoreBand/hfv4ScoreBands';

class StudentSelect extends PureComponent {
  constructor(props) {
    super(props);
    this._getLinkHrefForValue = (studentId) =>
      this.props.buildRoute({ studentId, mode: '' });
  }


  componentWillMount() {
    this._buildStudentSelectOptions();
  }

  componentWillReceiveProps(nextProps) {
    this._buildStudentSelectOptions(nextProps);
  }

  _buildStudentSelectOptions(props = this.props) {
    const { membersInCurrentProgressReport, studentScores } = props;
    // Invalidate cache when either members or scores change
    if (is.existy(this._studentSelectOptions) &&
      is.existy(this._membersInCurrentProgressReport) &&
      this._membersInCurrentProgressReport === membersInCurrentProgressReport &&
      this._studentScores === studentScores) {
      return;
    }

    if (membersInCurrentProgressReport && membersInCurrentProgressReport.size > 0) {
      this._membersInCurrentProgressReport = membersInCurrentProgressReport;
      this._studentScores = studentScores;
      this._studentSelectOptions = membersInCurrentProgressReport.map((option) => {
        const { studentGeneralInfo } = option;
        const scorePercentage = studentScores && studentScores.get(`${studentGeneralInfo.id}`);
        const band = is.number(scorePercentage) ? getHfv4BandForScore(scorePercentage) : null;
        const scoreStyle = band ? { color: band.color } : {};
        const optionHtml = <StudentCard vertical
            borderless
            backgroundless
            className={styles.StudentCard_hfv4}>
          <StudentCard.Profile name={studentGeneralInfo.firstName}
              surname={studentGeneralInfo.lastName}
              localName={studentGeneralInfo.localName}
              avatarUrl={studentGeneralInfo.avatarUrl}
              gender={studentGeneralInfo.gender} />
          {is.number(scorePercentage) &&
            <div className={styles.StudentSelect_score} style={scoreStyle}>{scorePercentage}%</div>
          }
        </StudentCard>;
        return {
          html: optionHtml,
          value: studentGeneralInfo.id,
          className: styles.StudentSelect_option,
        };
      });
    }
  }

  render() {
    const { currentMember, membersInCurrentProgressReport, isHide } = this.props;
    if (currentMember &&
      membersInCurrentProgressReport.size &&
      membersInCurrentProgressReport.size > 0) {
      return <div className={styles.StudentSelect}>
        <HorizontalSelect options={this._studentSelectOptions}
            value={currentMember && currentMember.studentGeneralInfo.id}
            getLinkHrefForValue={this._getLinkHrefForValue}
            isHide={isHide} />
      </div>;
    }
    return null;
  }
}

function mapStateToProps(state, ownProps) {
  const { studentId, groupId, progressReportId } = ownProps.params;
  const studentReportSummaries =
    state.get('rootReducer').get('studentReportSummaries').get(progressReportId);
  if (studentReportSummaries && studentReportSummaries.data) {
    const studentReportSummariesStudentIds =
      studentReportSummaries.data.toList().map((srs) => srs.studentId);
    const membersInCurrentProgressReport = GroupMembers.getMembersByGroup(state, groupId)
      .filter(({ studentGeneralInfo: { id } }) =>
      studentReportSummariesStudentIds.indexOf(`${id}`) !== - 1);

    let studentScores = null;
    try {
      const group = state.get('rootReducer').get('groups').get(groupId).data;
      const progressReportRecord = group.progressReports.data.get(progressReportId);
      if (progressReportRecord) {
        const { progressTestId } = progressReportRecord;
        const progressTest = state.get('rootReducer').get('progressTests').get(progressTestId);
        if (ApiResponseHelper.hasSucceeded(progressTest)) {
          studentScores = progressTest.data.studentProgressTestResults.map(
            (result) => result.totalScore.percentage,
          );
        }
      }
    } catch (e) { }

    return {
      currentMember: GroupMembers.getMemberById(state, studentId),
      membersInCurrentProgressReport,
      studentScores,
      isHide: ! UiState.getShowNavigationBar(state),
    };
  }
}

StudentSelect.propTypes = {
  currentMember: PropTypes.object,
  membersInCurrentProgressReport: PropTypes.object,
  studentScores: PropTypes.object,
  buildRoute: PropTypes.func,
  isHide: PropTypes.bool,
};

export default connect(mapStateToProps, null)(StudentSelect);



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/StudentSelect/index.jsx